import ApiClient from '@afosto/api/ApiClient';

class Groups {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Create a new pricing group
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Add a new pricing group to the list
   * @returns {Promise}
   */
  createPricingGroup(body, options = {}) {
    return this.apiClient.request({
      url: `/cat/groups`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Disable a pricing group
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Disabling a pricing group makes sure it cannot me added to new settings
   * @returns {Promise}
   */
  disableGroup(id, options = {}) {
    return this.apiClient.request({
      url: `/cat/groups/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Get a list of price groups
   *
   * @param {Object} options - The additional request options
   * @description Get a listing of available pricing groups
   * @returns {Promise}
   */
  getPricingGroups(options = {}) {
    return this.apiClient.request({
      url: `/cat/groups`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Update a pricing group
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update metadata or the name of the pricing group
   * @returns {Promise}
   */
  updateGroup(id, body, options = {}) {
    return this.apiClient.request({
      url: `/cat/groups/${id}`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * View a pricing group
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description View the pricing group by id
   * @returns {Promise}
   */
  viewGroup(id, options = {}) {
    return this.apiClient.request({
      url: `/cat/groups/${id}`,
      method: 'get',
      ...options,
    });
  }
}

export const groups = new Groups();

export default Groups;
